import React from "react";
import TextView from "../../../TextView";
import { Container } from "../../CreateWheelPopup.styled";
import CustomRadioButton from "../../CustomRadioButton";
// import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import EssentialPackageIcon from "@assets/images/packages/essentialPackageIcon.svg";
import { useSelector } from "react-redux";
import { getActiveSubscriptionData } from "../../../../redux/selectors/subscriptionSelectors";

function WheelColorTheme({ wheelPaletteOption, setWheelPaletteOption }) {
  const { data: currentPlan, loading: currentPlanLoading } = useSelector(
    getActiveSubscriptionData
  );
  return (
    <Container>
      <TextView variant="title" style={{ textAlign: "center" }}>
        Pick a color Theme!
      </TextView>

      <div style={{ marginTop: 40 }}>
        <CustomRadioButton
          options={[
            {
              value: 1,
              label: "Default",
              tooltip:
                "Segment colors are chosen from a pre-defined library of basic colors.",
            },
            {
              value: 2,
              label: "Customize",
              icon: currentPlan?.sub_tier === 0 && EssentialPackageIcon,
              iconTooltip: "Essential Tier feature",
              tooltip:
                "Generate a unique palette using AI, based on a text prompt, an image’s color scheme, or a selected base color.",
            },
          ]}
          selectedOption={wheelPaletteOption}
          onChange={(val) => setWheelPaletteOption(val.target.value)}
          orientation="vertical"
        />
      </div>
    </Container>
  );
}

export default WheelColorTheme;
